import {Component, Input, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {ReservationService} from '../../core/api/reservation.service';
import {getReservationPlansUrl} from '../../shared/models/reservation.model';
import {LangService} from '../../core/services/lang.service';

@Component({
  selector: 'others-2',
  templateUrl: './plans-and-services.component.html',
  imports: [DocumentViewerPageComponent]
})
export class PlansAndServicesComponent implements OnInit {
  @Input() url!: string;

  constructor(private reservationService: ReservationService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.loadReservation();
  }

  private loadReservation() {
    this.reservationService.getReservation().subscribe({
      next: (reservation) => {
        this.url = getReservationPlansUrl(reservation);
      },
      error: (error) => {
        console.error('Error al obtener planes:', error);
      }
    });
  }
}
